import React from 'react';
import Button from '../../Button';
import Card, { EmptyCard } from '../../Card';
import StatGrid from '../../StatGrid';
import { formatDuration } from '../../../domain/practice';
import { READING_WORDING as RW, figureOrDash, reading } from '../../../domain/reading';
import { useDateFormat } from '../../../context/LocaleContext';
import s from './tabs.module.css';
import t from '../../SimpleTable.module.css';

// `read`: the practice log has answered (`usePractice().loading`, #629). The
// overview's figures are the dash and the log says nothing until it has.
export default function PracticeLogTab({ sessions, read = true, failed = false, summary, today, onAddTime, onRemoveSession }) {
  // The studio's date pattern, not the stored `2026-09-05`.
  const formatDate = useDateFormat();
  const stats = [
    {
      key: 'days',
      value: figureOrDash(read, summary.daysThisWeek),
      label: <>Days practiced this week<br />{summary.daysLast30} in the last 30 days</>,
    },
    {
      key: 'hours',
      value: figureOrDash(read, formatDuration(summary.minutesThisWeek)),
      label: <>Hours this week<br />{formatDuration(summary.minutesLast30)} in the last 30 days</>,
    },
    {
      key: 'avg',
      value: figureOrDash(read, formatDuration(summary.averageMinutesPerDay)),
      label: <>Average a day<br />over the last 30 days</>,
    },
  ];

  return (
    <>
      <Card title="Practice Overview"><StatGrid stats={stats} /></Card>

      <div className={s.sectionHead}>
        <div className={s.sectionTitle}>Practice log as of {formatDate(today) || today}</div>
        <Button onClick={onAddTime}>+ Add Time</Button>
      </div>

      {sessions.length === 0 ? (
        <EmptyCard reading={reading(read, sessions.length, failed)}>{RW['student.practiceEmpty']}</EmptyCard>
      ) : (
        <div className={t.wrap}>
          <table className={t.table}>
            <thead><tr><th>Date</th><th>Duration</th><th>Note</th><th /></tr></thead>
            <tbody>
              {sessions.map((x) => (
                <tr key={x.id}>
                  <td>{formatDate(x.practicedOn) || x.practicedOn}</td>
                  <td>{formatDuration(x.minutes)}</td>
                  <td>{x.note || '–'}</td>
                  <td className={t.right}>
                    <button className={t.linkButton} onClick={() => onRemoveSession(x.id)}>Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
